import Vue from 'vue';
import { assign, find, has, get, clone } from 'lodash';
import * as api from 'api/api-stuff-to-eat';
import * as types from '../mutation-types';

const initState = {
  ready: false,
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: false,
  error: null,
  notFound: null,
  meta: {},
  data: {},
};

const neutralState = {
  fetching: false,
  fetched: true,
  saving: false,
  saveError: null,
  saved: false,
  error: null,
  notFound: null,
};

const state = {};

const findEnergyInformation = (data) => {
  const values = { energy_kcal: 0, energy_kj: 0 };
  const ener = find(data, item => item.code === 'ENER');

  if (ener) {
    const enercKj = find(ener.NutrientDefinition, item => item.code === 'ENERC_KJ');
    const enercKcal = find(ener.NutrientDefinition, item => item.code === 'ENERC_KCAL');

    values.energy_kj = get(enercKj, 'NutritionInformation.nutrition_value', 0);
    values.energy_kcal = get(enercKcal, 'NutritionInformation.nutrition_value', 0);
  }

  return values;
};

const getters = {
  StuffToEatDetails: state => id => state[id],
};

const actions = {
  InitStuffToEatDetails({ commit }, params) {
    const id = params.id;
    commit(types.CLEAR_STUFF_TO_EAT_DETAILS_STORE, { id });
  },
  GetStuffToEatDetails({ commit }, params) {
    const id = params.id;
    const type = params.type;
    commit(types.FETCH_STUFF_TO_EAT_DETAILS_START, { id });
    api.getDetails(
      type,
      id,
      (response) => {
        commit(types.RECEIVE_STUFF_TO_EAT_DETAILS, { id, response });
      },
      (description, status, error) => {
        console.log('error', status, error);
        if (status === 404) {
          commit(types.FETCH_STUFF_TO_EAT_DETAILS_NOT_FOUND, { id, error });
        } else {
          commit(types.FETCH_STUFF_TO_EAT_DETAILS_ERROR, { id, error });
        }
      },
    );
  },
  AddNewStuffToEat({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const payload = params.payload;
      console.log('AddNewStuffToEat', id, type, params);
      commit(types.SAVE_STUFF_TO_EAT_DETAILS_START, { id });
      api.addStuffToEat(
        type,
        payload,
        (response) => {
          console.log('save');
          commit(types.SAVE_STUFF_TO_EAT_DETAILS_SUCCESSFUL, { id, response });
          dispatch('AddToRecentlyModifiedList', { type, response });
          resolve(true);
        },
        (description, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.SAVE_STUFF_TO_EAT_DETAILS_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SaveStuffToEatDetails({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const payload = params.payload;
      commit(types.SAVE_STUFF_TO_EAT_DETAILS_START, { id });
      console.log('save data', params.data);
      api.saveDetails(
        type,
        id,
        payload,
        (response) => {
          console.log('save');
          commit(types.SAVE_STUFF_TO_EAT_DETAILS_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (description, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.SAVE_STUFF_TO_EAT_DETAILS_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SetStuffToEatMainImage({ commit }, { id, images }) {
    const image = find(images, image => image.main);
    console.log('SetStuffToEatMainImage', id, images, image);
    if (image) {
      commit(types.STUFF_TO_EAT_IMAGE_SET_MAIN_SUCCESSFUL, { id, image });
    }
  },
  SetNutritionInformationManualControl({ commit }, params) {
    const type = params.type;
    const id = params.id;
    const payload = params.payload;
    return new Promise((resolve, reject) => {
      commit(types.SET_STUFF_TO_EAT_NUTRITION_INFORMATION_MANUAL_CONTROL_START, { id });
      api.saveDetails(
        type,
        id,
        payload,
        (response) => {
          commit(types.SET_STUFF_TO_EAT_NUTRITION_INFORMATION_MANUAL_CONTROL_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (error, status, saveError) => {
          commit(types.SET_STUFF_TO_EAT_NUTRITION_INFORMATION_MANUAL_CONTROL_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SetAllergensManualControl({ dispatch, commit }, params) {
    const type = params.type;
    const id = params.id;
    const payload = params.payload;
    const reload = params.reload;

    return new Promise((resolve, reject) => {
      commit(types.SET_STUFF_TO_EAT_ALLERGENS_MANUAL_CONTROL_START, { id });
      api.saveDetails(
        type,
        id,
        payload,
        (response) => {
          if (reload) dispatch('GetStuffToEatAllergenDeclaration', { id, type });
          commit(types.SET_STUFF_TO_EAT_ALLERGENS_MANUAL_CONTROL_SUCCESSFUL, { id, response });
          resolve(true);
        },
        (error, status, saveError) => {
          commit(types.SET_STUFF_TO_EAT_ALLERGENS_MANUAL_CONTROL_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  AddServingSizeToStuffToEatDetails({ commit }, { id, response }) {
    console.log('AddServingSizeToStuffToEatDetails', response);
    commit(types.ADD_SERVING_SIZE_TO_STUFF_TO_EAT_DETAILS, { id, response });
  },
  UpdateStuffToEatDetailsNutritionInfo({ commit }, { id, response }) {
    commit(types.UPDATE_STUFF_TO_EAT_DETAILS_NUTRITION_INFO, { id, response });
  },
  SetStuffToEatDetailsManualNutrition({ commit }, { id }) {
    commit(types.SET_STUFF_TO_EAT_DETAILS_MANUAL_NUTRITION, { id });
  },
  DeleteStuffToEat({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      console.log('DeleteStuffToEat', id, type);
      commit(types.DELETE_STUFF_TO_EAT_START, { id });
      api.deleteStuffToEat(
        type,
        id,
        () => {
          commit(types.DELETE_STUFF_TO_EAT_SUCCESSFUL, { id });
          dispatch('RemoveFromRecentlyModifiedList', { type, id });
          resolve(true);
        },
        (description, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.DELETE_STUFF_TO_EAT_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SaveStuffToEatStatus({ commit }, params) {
    return new Promise((resolve, reject) => {
      const id = params.id;
      const type = params.type;
      const payload = params.payload;

      commit(types.SAVE_STUFF_TO_EAT_STATUS_START, { id });
      console.log('save data', params.data);
      api.saveStatus(
        type,
        id,
        payload,
        (response) => {
          console.log('save');
          commit(types.SAVE_STUFF_TO_EAT_STATUS_SUCCESSFUL, { id, response, payload });
          resolve(true);
        },
        (description, status, saveError) => {
          console.log('error', status, saveError);
          commit(types.SAVE_STUFF_TO_EAT_STATUS_ERROR, { id, saveError });
          reject(saveError);
        },
      );
    });
  },
  SyncStuffToEatDetailsNutritionInfo({ commit }, params) {
    const id = params.id;
    const type = params.type;

    commit(types.SYNC_STUFF_TO_EAT_DETAILS_NUTRITION_INFO_START, { id });
    api.getDetails(
      type,
      id,
      (response) => {
        commit(types.SYNC_STUFF_TO_EAT_DETAILS_NUTRITION_INFO_SUCCESSFUL, { id, response });
      },
      (description, status, error) => {
        commit(types.SYNC_STUFF_TO_EAT_DETAILS_NUTRITION_INFO_ERROR, { id, error });
      },
    );
  },
  ClearStuffToEatDetails({ commit }, { id }) {
    commit(types.CLEAR_STUFF_TO_EAT_DETAILS_STORE, { id });
  },
  SetStuffToEatDetailsNeutralState({ commit }, { id }) {
    commit(types.SET_STUFF_TO_EAT_DETAILS_STORE_NEUTRAL_STATE, { id });
  },
};

const mutations = {
  [types.FETCH_STUFF_TO_EAT_DETAILS_START](state, { id }) {
    if (has(state, id)) Vue.set(state, id, assign(state[id], neutralState, { fetching: true }));
    else Vue.set(state, id, assign({}, initState, { fetching: true }));
  },
  [types.FETCH_STUFF_TO_EAT_DETAILS_NOT_FOUND](state, { id }) {
    Vue.set(state, id, assign(state[id], initState, { notFound: true }));
  },
  [types.FETCH_STUFF_TO_EAT_DETAILS_ERROR](state, { id, error }) {
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.RECEIVE_STUFF_TO_EAT_DETAILS](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { ready: true, data: response.data, meta: response.meta }));
  },

  [types.CLEAR_STUFF_TO_EAT_DETAILS_STORE](state, { id }) {
    console.log('CLEAR_STUFF_TO_EAT_DETAILS_STORE');
    Vue.set(state, id, assign({}, initState));
  },

  [types.SET_STUFF_TO_EAT_DETAILS_STORE_NEUTRAL_STATE](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState));
  },

  [types.SAVE_STUFF_TO_EAT_DETAILS_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SAVE_STUFF_TO_EAT_DETAILS_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SAVE_STUFF_TO_EAT_DETAILS_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { saved: true, data: response.data, meta: response.meta }));
  },
  [types.STUFF_TO_EAT_IMAGE_SET_MAIN_SUCCESSFUL](state, { id, image }) {
    Vue.set(state, id, assign(state[id], neutralState));
    Vue.set(state[id].data, 'Image', image);
  },
  [types.STUFF_TO_EAT_IMAGE_SET_MAIN_ERROR](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { error: 'Error set main image!' }));
  },
  [types.ADD_SERVING_SIZE_TO_STUFF_TO_EAT_DETAILS](state, { id, response }) {
    const userAdded = get(state[id], 'data.EntityServingSizes.available_serving.user_added', false);
    const data = response.data;
    if (has(userAdded, 'list')) userAdded.list.push(data);
    Vue.set(state[id].data.EntityServingSizes, 'selected_serving', clone(data));
  },
  [types.DELETE_STUFF_TO_EAT_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.DELETE_STUFF_TO_EAT_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.DELETE_STUFF_TO_EAT_SUCCESSFUL](state, { id }) {
    Vue.set(state, id, assign(state[id], initState));
  },

  [types.SET_STUFF_TO_EAT_NUTRITION_INFORMATION_MANUAL_CONTROL_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SET_STUFF_TO_EAT_NUTRITION_INFORMATION_MANUAL_CONTROL_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SET_STUFF_TO_EAT_NUTRITION_INFORMATION_MANUAL_CONTROL_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { data: response.data, meta: response.meta }));
  },

  [types.SET_STUFF_TO_EAT_ALLERGENS_MANUAL_CONTROL_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SET_STUFF_TO_EAT_ALLERGENS_MANUAL_CONTROL_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SET_STUFF_TO_EAT_ALLERGENS_MANUAL_CONTROL_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { data: response.data, meta: response.meta }));
  },

  [types.SAVE_STUFF_TO_EAT_STATUS_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState, { saving: true }));
  },
  [types.SAVE_STUFF_TO_EAT_STATUS_ERROR](state, { id, saveError }) {
    Vue.set(state, id, assign(state[id], neutralState, { saveError }));
  },
  [types.SAVE_STUFF_TO_EAT_STATUS_SUCCESSFUL](state, { id, response }) {
    Vue.set(state, id, assign(state[id], neutralState, { saved: true, meta: response.meta, data: response.data }));
  },

  [types.SYNC_STUFF_TO_EAT_DETAILS_NUTRITION_INFO_START](state, { id }) {
    Vue.set(state, id, assign(state[id], neutralState));
  },
  [types.SYNC_STUFF_TO_EAT_DETAILS_NUTRITION_INFO_ERROR](state, { id, error }) {
    Vue.set(state, id, assign(state[id], neutralState, { error }));
  },
  [types.SYNC_STUFF_TO_EAT_DETAILS_NUTRITION_INFO_SUCCESSFUL](state, { id, response }) {
    const energyKj = get(response, 'data.energy_kj', 0);
    const energyKcal = get(response, 'data.energy_kcal', 0);

    Vue.set(state[id].data, 'energy_kj', energyKj);
    Vue.set(state[id].data, 'energy_kcal', energyKcal);
  },

  [types.SET_STUFF_TO_EAT_DETAILS_MANUAL_NUTRITION](state, { id }) {
    Vue.set(state[id].data, 'manual_nutrition', false);
  },

  [types.UPDATE_STUFF_TO_EAT_DETAILS_NUTRITION_INFO](state, { id, response }) {
    const energyInformation = findEnergyInformation(response.data);
    Vue.set(state[id].data, 'energy_kcal', energyInformation.energy_kcal);
    Vue.set(state[id].data, 'energy_kj', energyInformation.energy_kj);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/stuff-to-eat/entities/stuff-to-eat-details.js